// Design tokens for BIBbib application

import Kangaro from "./assets/fonts/Kangaro.ttf";

const fontFaces = `
  @font-face {
    font-family: "Kangaro";
    src: url('${Kangaro}') format('truetype');
    font-weight: 400;
  }
`;

if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.innerHTML = fontFaces;
  document.head.appendChild(style);
}

export const theme = {
  // Primary Colors
  colors: {
    // Neutrals
    white: "#ffffff",
    black: "#000000",
    gray50: "#f9fafb",
    gray100: "#f3f4f6",
    gray200: "#e5e7eb",
    gray300: "#d1d5db",
    gray400: "#9ca3af",
    gray500: "#6b7280",
    gray600: "#4b5563",
    gray700: "#374151",
    gray800: "#1f2937",
    gray900: "#111827",

    // Brand Primary - Dark & Light theme
    dark: "#0F172A",
    darkLight: "#1a2843",
    darkLighter: "#2d3e5f",
    
    light: "#B6F400",
    lightDark: "#99cc00",
    lightDarker: "#7da600",

    // Accent variations
    accent: "#B6F400",
    accentDark: "#99cc00",
    accentLight: "#d1ff4d",

    // Text
    text: "#ffffff",
    textSecondary: "#d1d1d1",
    textMuted: "#a0a0a0",
    textLight: "#B6F400",
    textInverted: "#0F172A",

    // Borders & Dividers
    border: "#2d3e5f",
    divider: "#3d4e6f",

    // Backgrounds
    bg: "#ffffff",
    bgLight: "#f8f9fa",
    bgPage: "#f5f7fb",
    bgDark: "#0F172A",
    bgDarkSecondary: "#1a2843",

    // Status Colors
    success: "#10b981",
    successBg: "#f0fdf4",
    error: "#ef4444",
    errorBg: "#fee2e2",
    warning: "#f59e0b",
    warningBg: "#fffbeb",
    info: "#B6F400",
    infoBg: "#f0ff99",

    // Shadows
    shadowLight: "rgba(11, 23, 42, 0.05)",
    shadowMedium: "rgba(11, 23, 42, 0.1)",
    shadowHeavy: "rgba(11, 23, 42, 0.35)",
  },

  // Typography
  fonts: {
    family: {
      primary: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      mono: "'Courier New', monospace",
      logo: "'Kangaro'",
    },
    size: {
      xs: "12px",
      sm: "13px",
      base: "14px",
      md: "16px",
      lg: "18px",
      xl: "20px",
      xxl: "24px",
      xxxl: "28px",
      huge: "32px",
      massive: "48px",
      giant: "64px",
      heroTitle: "72px",
    },
    weight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.75,
      loose: 2,
    },
  },

  // Spacing
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    xxl: "24px",
    xxxl: "32px",
    huge: "40px",
  },

  // Border Radius
  radius: {
    none: "0px",
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
    full: "999px",
  },

  // Shadows
  shadows: {
    sm: "0 1px 2px rgba(0,0,0,0.05)",
    md: "0 2px 4px rgba(0,0,0,0.05)",
    lg: "0 4px 12px rgba(0,0,0,0.1)",
    xl: "0 12px 40px rgba(0,0,0,0.08)",
    xxl: "0 12px 40px rgba(0,0,0,0.25)",
  },

  // Transitions
  transitions: {
    fast: "0.15s ease",
    base: "0.2s ease",
    slow: "0.3s ease",
    slower: "0.5s ease",
  },

  // Z-index
  zIndex: {
    hide: "-1",
    auto: "auto",
    base: "0",
    dropdown: "10",
    sticky: "20",
    fixed: "30",
    backdrop: "40",
    modal: "50",
    popover: "60",
    tooltip: "70",
  },

  // Breakpoints (for responsive design)
  breakpoints: {
    xs: "320px",
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    xxl: "1536px",
  },

  //Size for icons
    iconSize: {
    sm: "16px",
    md: "24px",
    lg: "32px",
    xl: "48px",
  },
};

export default theme;
